export {
  indexRuntimeInteractions,
  isRuntimeNodeDisabled,
  needsRuntimeButtonSemantics,
  runtimeClickTargets,
  type RuntimeInteractionIndex,
} from "../../../util/src/layout-compiler/runtimeNodeInteractions.js";

export const RUNTIME_INTERACTION_CSS = `
[data-layout-clickable="true"] { cursor: pointer; }
[data-layout-clickable="true"][aria-disabled="true"] { cursor: default; }
[data-layout-clickable="true"][role="button"]:focus-visible { outline: 2px solid currentColor; outline-offset: -2px; }
`;
